export enum TimelineStatus {
  COMPLETE = 'complete',
  IN_PROGRESS = 'in_progress',
  DELAYED = 'delayed',
  NOT_STARTED = 'not_started',
}